<ng-container [formGroup]="metadataFormGroup">
  <div class="row mb-3">
    <div class="col">
      <label i18n>Animal à assurer</label>
      <select class="form-control" formControlName="animalType">
        <option *ngFor="let value of animalValues" [ngValue]="value">
          {{ getAnimalLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-1 my-3">
    <div class="col">
      <label i18n>Franchise</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="deductibleValue"
      />
    </div>
    <div class="col" *ngIf="metadataFormGroup.value.animalType === Animal.DOG">
      <label i18n>Race</label>
      <select class="form-control" formControlName="dogRace">
        <option *ngFor="let race of dogRaces" [ngValue]="race.value">
          {{ race.label }}
        </option>
      </select>
    </div>
    <div
      class="row row-cols-2 mt-16"
      *ngIf="metadataFormGroup.value.animalType === Animal.CAT"
    >
      <div class="col">
        <label i18n>Race</label>
        <input class="form-control" formControlName="catRace" />
      </div>
      <div class="col">
        <label i18n> Chat </label>
        <div class="form-check" *ngFor="let type of catTypeValues">
          <input
            type="radio"
            name="catType"
            [id]="type"
            [value]="type"
            formControlName="catType"
          />
          <label class="form-check-label" [for]="type">
            {{ getCatTypeLabel(type) }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3">
    <div class="col">
      <label i18n>Début d'assurance immédiat ?</label>
      <div class="form-check">
        <input
          type="radio"
          name="isImmediateInsuranceStart"
          id="isImmediateInsuranceStartFalse"
          [value]="false"
          formControlName="isImmediateInsuranceStart"
        />
        <label class="form-check-label" for="isImmediateInsuranceStartFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="isImmediateInsuranceStart"
          id="isImmediateInsuranceStartTrue"
          [value]="true"
          formControlName="isImmediateInsuranceStart"
        />
        <label class="form-check-label" for="isImmediateInsuranceStartTrue">
          Oui
        </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="metadataFormGroup.value.isImmediateInsuranceStart === false"
    >
      <label i18n>Date</label>
      <input
        type="date"
        class="form-control"
        formControlName="insuranceStartDate"
      />
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Genre</label>
      <div class="form-check" *ngFor="let value of sexValues">
        <input
          type="radio"
          name="sex"
          [id]="value"
          [value]="value"
          formControlName="sex"
        />
        <label class="form-check-label" [for]="value">
          {{ getSexEnumLabel(value) }}
        </label>
      </div>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3">
    <div class="col">
      <label i18n>Nom de l'animal</label>
      <input type="text" class="form-control" formControlName="name" />
    </div>
    <div class="col">
      <label i18n>Date de naissance</label>
      <input type="date" class="form-control" formControlName="birthDate" />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3">
    <div class="col">
      <label i18n>Couleur</label>
      <input type="text" class="form-control" formControlName="color" />
    </div>
    <div class="col">
      <label i18n>Numéro de puce électronique (si disponible)</label>
      <input type="text" class="form-control" formControlName="chipNumber" />
    </div>
  </div>
</ng-container>
